var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfileGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_673_1997",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_673_1997)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8242 31.1562H71.8514L67.4935 21.3595C67.11 20.5228 66.308 20 65.4016 20H35.3841C34.4777 20 33.641 20.5228 33.2924 21.3595L28.9344 31.1562H21.9617C18.6846 31.1562 16 33.8407 16 37.1179V74.0385C16 77.3156 18.6846 80 21.9617 80H73.2808H73.4899H78.8591C82.1362 80 84.8206 77.3156 84.8206 74.0385V37.1179C84.7857 33.8059 82.1362 31.1562 78.8242 31.1562ZM37.3714 22.5799H63.4143C64.1116 22.5799 64.7392 22.9982 65.0181 23.6257L68.5394 31.47H32.2812L35.8025 23.6257C36.0465 22.9982 36.6741 22.5799 37.3714 22.5799ZM81.0555 74.5613C81.0555 75.3283 80.4278 75.9559 79.6608 75.9559H74.1174H73.9083H21.0902C20.3232 75.9559 19.6955 75.3283 19.6955 74.5613V36.5602C19.6955 35.7932 20.3232 35.1656 21.0902 35.1656H29.806H70.945H79.6608C80.4278 35.1656 81.0555 35.7932 81.0555 36.5602V74.5613Z",
    fill: "#D8A777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3739 38.0593C40.7167 38.0593 32.8726 45.9035 32.8726 55.5607C32.8726 65.2179 40.7167 73.0622 50.3739 73.0622C60.0311 73.0622 67.8755 65.2179 67.8755 55.5607C67.8755 45.9383 60.0311 38.0593 50.3739 38.0593ZM50.3739 69.9593C42.425 69.9593 35.9753 63.5096 35.9753 55.5607C35.9753 47.6118 42.425 41.162 50.3739 41.162C58.3228 41.162 64.7726 47.6118 64.7726 55.5607C64.7726 63.5096 58.3228 69.9593 50.3739 69.9593Z",
    fill: "#D8A777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3762 44.7181C44.3797 44.7181 39.5337 49.5989 39.5337 55.5606C39.5337 61.5571 44.4145 66.4033 50.3762 66.4033C56.3727 66.4033 61.2189 61.5222 61.2189 55.5606C61.2538 49.5989 56.3727 44.7181 50.3762 44.7181ZM50.3762 62.917C46.332 62.917 43.02 59.6048 43.02 55.5606C43.02 51.5164 46.332 48.2044 50.3762 48.2044C54.4204 48.2044 57.7326 51.5164 57.7326 55.5606C57.7326 59.6396 54.4204 62.917 50.3762 62.917Z",
    fill: "#D8A777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3279 38.4427H67.8765V41.8941H71.3279V38.4427Z",
    fill: "#D8A777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4627 38.4427H74.0112V41.8941H77.4627V38.4427Z",
    fill: "#D8A777"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileGold);
export default __webpack_public_path__ + "static/media/icon_profile_gold.0ac13e3241c37ddfc4a70b930b979199.svg";
export { ForwardRef as ReactComponent };